export default "__VITE_ASSET__mZ5gF7Hd__";